module.exports = __webpack_public_path__ + "static/media/group-customer-fixed.1a403e2a.png";